import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { MainLayout } from './layouts/MainLayout';
import { CodingWorksheetPrint, CodingWorksheetNew, AssureContext, CustomerWorksheetPrint } from './components';
import AuthContextProvider from './contexts/AuthContext';
import CodingWorksheetView from './components/codingworksheet/CodingWorksheetView';
const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)

//const MainLayout = React.lazy(() => import('./layouts/MainLayout'));

const Login = React.lazy(() => import('./components/Login'));
const Page404 = React.lazy(() => import('./components/Page404'));
const Page500 = React.lazy(() => import('./components/Page500'));

export default () => (
    <React.Suspense fallback={loading}>
        <Switch>
            <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
            <Route exact path="/login/:confirmCode?" name="Login Page" render={props => <Login {...props} />} />
            <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
            <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />

            <Route exact path="/coding/worksheet/view/:id" name="Worksheet View" render={props => <AssureContext><CodingWorksheetView {...props} /></AssureContext>} />
            <Route exact path="/coding/worksheet/print/:id" name="Worksheet Print" render={props => <AssureContext><CodingWorksheetPrint {...props} /></AssureContext>} />
            <Route exact path="/coding/worksheet/:id" name="Worksheet Print" render={props => <CodingWorksheetNew {...props} />} />
            <Route exact path="/coding/worksheetview/:id" name="Worksheet View" render={props => <CodingWorksheetView {...props} />} />
            <Route exact path="/customer/worksheet/:id" name="Customer Worksheet Print" render={props => <AssureContext><CustomerWorksheetPrint {...props} /></AssureContext>} />
            <AuthContextProvider>
                <AssureContext>
                    <Route path="/" name="Home" render={props => <MainLayout {...props} />} />
                </AssureContext>
            </AuthContextProvider>
        </Switch>
    </React.Suspense>
);
